export function Home() {
  
  return <h1 className='text-5xl'>Home</h1>
}